// add ?react for svg to be used as a component (svgr)
import GeneralIcon from "assets/general.svg?react";
import SettingsIcon from "assets/settings.svg";
import { SidebarLayout } from "src/layout/SidebarLayout/SidebarLayout";

const GeneralIconComponent = () => {
  return <GeneralIcon height={24} width={24} />;
};

export const OrgNavSection = () => (
  <SidebarLayout.SidebarMainLayout.SidebarSection
    title="Organization"
    alt="organization"
    iconSrc={SettingsIcon}
  >
    <SidebarLayout.SidebarMainLayout.ListNavLink
      to="/home/org-settings"
      label="General"
      iconSvg={<GeneralIconComponent />}
    />
    <SidebarLayout.SidebarMainLayout.ListNavLink
      to="/home/org-users"
      label="Users"
      iconSvg={<GeneralIconComponent />}
    />
    {/* Billing Page is out of date */}
    {/* {import.meta.env.VITE_ALPHA_MODE === "true" && (
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to="/home/org-billing"
        label="Billing"
        iconSvg={<GeneralIconComponent />}
      />
    )} */}
  </SidebarLayout.SidebarMainLayout.SidebarSection>
);
